<template>
    <div style="background:white; height:100%;display:flex"> 
        <div style="width:318px">
            <el-table  :data="supData" 
                border                            
                size="small"   
                :row-key="getRowKey" 
                v-loading="v_loading"
                element-loading-background = "rgba(255, 255, 255, .5)"
                :element-loading-text="$LANG('1959', '加载中')"
                element-loading-spinner = "el-icon-loading"
                :height="subHeight" 
                header-cell-class-name="clearPadding"
                :row-class-name="tabRowClass"
                :header-cell-style="{ 'color':'#389','text-align':'center'}"
                class="custom-table-border"
                ref="refsup"
                @row-click="supClick"
                highlight-current-row
                style="overflow:auto;margin-top:1px;"> 
                <el-table-column :label="$LANG('0310', '序号')" type="index" width="50" fixed>
                    <el-table-column  type="index" width="50" fixed>
                    </el-table-column>
                </el-table-column> 
                <el-table-column  v-for="(item,index ) in supCol " :key="index"
                    :prop="item.key"
                    :label="item.title+v_title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    :min-width="item.width">
                    <el-table-column    :prop="item.key"   show-overflow-tooltip :min-width="item.width">
                        <template slot="header"  slot-scope="scope" >
                            {{scope.row}}
                            <el-input  @keyup.enter.native="getSupList(v_empno,notAcc)" clearable  v-model="v_empno" size="mini" :placeholder="$LANG('1663', '请输入')" >
                                <el-button size="mini" slot="append" icon="el-icon-search" @click="getSupList(v_empno,notAcc)" style="color:#409eff"></el-button>
                            </el-input> 
                        </template>
                        <template slot-scope="scope">
                            <div v-text="scope.row[item.key]" style=" font-size:12px; "> </div>
                        </template>
                    </el-table-column>
                </el-table-column> 
 
            </el-table>
        </div>
        <div  style="min-width:1200px" class="ve-list-page ve-list-page--embedded ve-list-page--pane">
        <div style="border-bottom:2px solid #389;padding-top:3px;background:white;display:flex;line-height:30px;height:35px">
            <div style="width:1200px;display:flex">
                <div style=" font-size:12px;margin-left:5px;width:65px;font-weight:600;color:#389 ">{{ $LANG('0074', '支付状态') }}：</div>
                <el-radio-group v-model="notAcc" size="mini" @input="chkChg">
                    <el-radio-button label="ALL">{{ $LANG('0040', '所有记录') }}</el-radio-button>
                    <el-radio-button label="C">{{ $LANG('2041', '待支付-所有') }}</el-radio-button>
                    <el-radio-button label="C2">{{ $LANG('1538', '待支付-报销未审核') }}</el-radio-button>
                    <el-radio-button label="C3">{{ $LANG('1537', '待支付-报销已审核') }}</el-radio-button>
                    <el-radio-button label="NN">{{ $LANG('1535', '已支付未送货未开票') }}</el-radio-button>
                    <el-radio-button label="YN">{{ $LANG('1534', '已支付已送货未开票') }}</el-radio-button>
                    <el-radio-button label="Y">{{ $LANG('1975', '已完结') }}</el-radio-button>
                </el-radio-group>
 
                <el-button :disabled="cfmBool " type="danger" @click="accRec" icon="iconfont icon-fapiaoguanli" size="mini" style="width:70px; height:28px;margin-left:15px">{{ $LANG('0390', '记账') }}</el-button>
                <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
                <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
            </div> 
        </div>
        <div style="width:100%" class="ve-list-page__body">
            <div class="ve-list-page__table">
            <ve-table :columns="vueCol" 
                    :table-data="tabData" 
                    :columnHiddenOption="columnHiddenOption"
                    style="margin-top:0px; "
                    :border-around="true"
                    :border-x="true" 
                    :border-y="true" 
                    :fixed-header="true"
                    row-key-field-name="IDSEQ"
                    :row-style-option="rowStyleOption"
                    :cell-style-option="cellStyleOption"
                    :max-height="tabHeight" 
                    :virtual-scroll-option="virtualScrollOption"
                    :scroll-width="0"     
                    :footer-data="footerData"              
                    :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"                    
                    :column-width-resize-option="columnWidthResizeOption"
                    :cellSelectionOption="{enable: false,}"
                    id="check_pay"
                    ref="tableRef" >
 
            </ve-table>
            </div>
            <div style="margin-top:2px" class="ve-list-page__pagination">
                <ve-pagination
                    :total="dataCount"
                    :page-index="pageIndex"
                    :page-size="pageSize"
                    :page-size-option="pageList"
                    @on-page-number-change="pageNumberChange"
                    @on-page-size-change="pageSizeChange"
                />
            </div>
        </div>
        <!-- 提示框 -->
        <el-dialog  :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">{{ $LANG('1638', '确定') }}</el-button>
            </span>
        </el-dialog>
        <!-- 数据查看 -->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="addWin" :width="dlgWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:89vh;overflow-y:auto">
                <Form ref="addForm" :model="formCol" :label-width="120"  :rules="ruleValidate"  label-position="right" inline >
                    <span v-for="(item,index) in tabArr" :key="index" >
                        <FormItem :class="item.key=='REASON'?'item-width2':'item-width'"  :label="item.title" :prop="item.key" v-if="item.fhide==='N'">                                  
                            <el-checkbox size="medium" border v-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="formCol[item.key]" style="width:100%"></el-checkbox> 
                            <el-input  size="medium" type="textarea" :rows="2"  v-else-if="item.key==='REASON'"   v-model="formCol[item.key]"></el-input> 
                            <el-select size="medium" @change="selectChg(item.key)" :disabled="saveFlag" v-else-if="item.edcss==='select'" v-model="formCol[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                            </el-select>
                            <el-select size="medium" filterable disabled v-else-if="item.key==='EMPNO' " v-model="formCol[item.key]"   style="width:100%">
                                <el-row v-for="(item ,index) in empArr " :key="index">
                                    <el-col :span="4">
                                        <el-option  :label="item.TY" :value="item.EMPNM"></el-option>
                                    </el-col>
                                    <el-col :span="10">
                                        <el-option  :label="item.DEPTNM" :value="item.EMPNM"></el-option>
                                    </el-col>
                                    <el-col :span="10">
                                        <el-option  :label="item.EMPNM" :value="item.EMPNM"></el-option>
                                    </el-col>
                                </el-row>
                            </el-select>
                            <el-select v-else-if="item.key==='ISTAX'" v-model="formCol[item.key]" size="medium" style="width:100%">
                                <el-option :label="$LANG('0283', '含税')" value="Y"></el-option>
                                <el-option :label="$LANG('0423', '不含税')" value="N"></el-option>
                            </el-select> 
                            <el-date-picker size="medium" type="date"  v-else-if="item.edcss==='date'" v-model="formCol[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>    
                            <el-input-number size="medium" controls-position="right" v-else-if="item.edcss==='number'"  style="width:100%" v-model="formCol[item.key]"></el-input-number> 
                            <el-input size="medium" :placeholder="item.holder" type="text" v-else  :disabled="item.disabled==='Y'?true:false||saveFlag||(item.key=='FINVNO'&&hapBool)"  v-model="formCol[item.key]"></el-input>
                        </FormItem>
                    </span>
                </Form>
                <div style="background:#808695;border-left:2px solid #409eff;line-height:30px;color:white;padding-left:10px;font-size:14px"> {{ $LANG('2089', '报销费用明细') }}【
                   <i class="iconfont icon-xinzeng" style="color:#fff;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="saveFlag"  @click="addDtl" :underline="false" ><span style="font-size:12px;margin-right:5px;color:white">{{ $LANG('0095', '新增记录') }}</span></el-link>
                    】
                </div>  
                <el-table  :data="dtlData" 
                        border                            
                        disabled-hover
                        class="custom-table-border"
                        size="small"
                        style="overflow:auto;margin-top:1px;"
                        :height="dtlHeight" 
                        :cell-style="{padding:'2px'}"
                        :row-key="getDtlKey"  
                        show-summary
                        :summary-method="getSummary"
                        ref="dtlref" 
                        highlight-current-row>
                    <el-table-column type="index" :label="$LANG('0310', '序号')" width="60" fixed></el-table-column>
                    <span v-for="(item,index ) in dtlArr" :key="index">
                        <el-table-column  v-if="item.thide==='N' &&item.edcss!=='checkbox'&&item.key!=='PAYIDNO' && item.key!=='PATH'"
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"                    
                            sortable
                            :min-width="item.width">
                        </el-table-column> 
                        <el-table-column  v-if="item.edcss=='checkbox'&&item.key!=='SEL'"
                            :prop="item.key"
                            :label="item.title"
                            :align="item.align"                                  
                            width="80">
                            <template slot-scope="scope">
                                <el-checkbox  disabled true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                            </template>
                        </el-table-column>
                        <el-table-column  v-if="item.key=='PAYIDNO'"
                            :prop="item.key"
                            :label="item.title"
                            align="center"
                            show-overflow-tooltip                                  
                            width="105">
                            <template slot-scope="scope" >
                                <el-link  :underline="false" @click="seeDay(scope.row[item.key])"><div style="color:#409eff;border-bottom:1px solid red ">{{scope.row[item.key]}}</div> </el-link>
                            </template>
                        </el-table-column>
                        <el-table-column  v-if="item.key=='PATH'"
                            :prop="item.key"
                            :label="item.title"
                            align="center"
                            show-overflow-tooltip                                  
                            width="80">
                            <template slot-scope="scope" >
                                <el-link  :underline="false" @click="seeLink(scope.row[item.key])"><div style="color:#409eff;border-bottom:1px solid red ">{{scope.row[item.key]}}</div> </el-link>
                            </template>
                        </el-table-column>
                    </span>
                    <el-table-column
                        fixed="right"
                        :label="$LANG('0330', '操作')"
                        align="center"
                        width="170">
                        <template slot-scope="scope">
                            <i class="iconfont icon-shangchuan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link  @click="upImg(scope.row,scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px;">{{ $LANG('0291', '图片') }}</span></el-link>
                            <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :disabled="typeof(scope.row['PAYIDNO'])=='string'"  @click="dtlEdit(scope.row ,scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px;">{{ $LANG('1639', '编辑') }}</span></el-link>
                            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :disabled="typeof(scope.row['PAYIDNO'])=='string'" @click="dtlDel(scope.row ,scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:2px;">{{ $LANG('0131', '删除') }}</span></el-link>
                        </template>
                    </el-table-column>  
                </el-table>  
                <!-- 单据明细 -->
                <div style="background:#808695;border-left:2px solid #409eff;line-height:30px;color:white;padding-left:10px;font-size:14px"> {{ $LANG('2086', '费用摊分明细') }}  【
                    <el-select size="small" v-model="billType" style="width:180px">
                        <el-option v-for="(item,index) in tyArr" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                    </el-select>
                    <i class="iconfont icon-xinzeng" style="color:#fff;font-size:14px;margin-right:5px;margin-left:10px;"></i>
                    <el-link :disabled="saveFlag" @click="addList" :underline="false" ><span style="font-size:12px;margin-right:5px;color:white">{{ $LANG('0597', '关联单据') }}</span></el-link>
                    <i class="iconfont icon-fenzhijiedian" style="color:#fff;font-size:14px;margin-right:5px;margin-left:20px;"></i>
                    <el-link :disabled="saveFlag" @click="disFee" :underline="false" ><span style="font-size:12px;margin-right:5px;color:white">{{ $LANG('0608', '分摊费用') }}</span></el-link>
                    】
                </div> 
                <el-table  :data="listData" 
                        border                            
                        disabled-hover
                        style="overflow:auto;margin-top:1px;"
                        size="small"
                        :height="200" 
                        :cell-style="{padding:'2px'}"
                        :row-key="getListKey"  
                        show-summary
                        :summary-method="getListSum"
                        ref="listref" 
                        class="custom-table-border"
                        highlight-current-row>
                    <el-table-column type="index" width="60" :label="$LANG('0310', '序号')" fixed ></el-table-column>
                    <span v-for="(item,index ) in listArr" :key="index">
                        <el-table-column  v-if="item.thide==='N'  "
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"                                  
                            sortable
                            :min-width="item.width">
                        </el-table-column> 
                    </span>
                    <el-table-column
                        fixed="right"
                        :label="$LANG('0330', '操作')"
                        align="center"
                        width="75">
                        <template slot-scope="scope">
                             
                            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link  @click="listDel(scope.row ,scope.$index)" :underline="false"  ><span style="font-size:12px; ">{{ $LANG('0131', '删除') }}</span></el-link>
                        </template>
                    </el-table-column>  
                </el-table>  
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <span :style="stfgColor">
                        <i class="iconfont" :class="stfgCss"  style="font-size:30px; margin-left:40px;margin-right:70px;height:35px;vertical-align:middle"></i>
                    </span>
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="addWin=false" style="margin-right:25px;">{{ $LANG('0132', '取消') }}</el-button>
 
                </span>
            </div>
        </el-dialog>
        <!-- 明细表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="dtlWin" :width="dlgWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{addFlag=='create'?$LANG('0095', '新增记录'):$LANG('0921', '编辑记录')}}</span>
            </div> 
            <Form  :model="dtlCol" :label-width="120"  :rules="dtlValidate" label-position="right" inline >
                <span v-for="(item,index) in dtlArr" :key="index" >
                    <FormItem :class="item.key=='REASON'?'item-width2':'item-width'"  :label="item.title" :prop="item.key" v-if="item.fhide==='N'">                                  
                        <el-checkbox border v-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="dtlCol[item.key]" style="width:100%"></el-checkbox> 
                        <el-input   type="textarea" :rows="2"  v-else-if="item.key==='REASON'"   v-model="dtlCol[item.key]"></el-input> 
                        <el-select filterable :disabled="saveFlag||item.disabled=='Y'" v-else-if="item.edcss==='select'" v-model="dtlCol[item.key]"   style="width:100%">
                            <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                        </el-select>
                        <el-select :disabled="saveFlag" v-else-if="item.key==='DISTY'" v-model="dtlCol[item.key]"  @change="disChg" style="width:100%">
                            <el-option v-for="(item,index) in disArr " :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                        </el-select>
                        <el-select filterable  :disabled="saveFlag" v-else-if="item.key==='ACNO'" v-model="dtlCol[item.key]"  @change="acChg" style="width:100%">
                            <el-row v-for="(item ,index) in subArr " :key="index">
                                <el-col :span="6">
                                    <el-option  :label="item.IDNO" :value="item.IDNO"></el-option>
                                </el-col>
                                <el-col :span="18">
                                    <el-option  :label="item.CNAME" :value="item.IDNO"></el-option>
                                </el-col>
                            </el-row>
                            <!-- <el-option
                                v-for="(item ,index) in subArr " :key="index" :label="item.CNAME" :value="item.IDNO">
                                <span style="float: left">{{ item.CNAME }}</span>
                                <span style="float: right; color: #8492a6; font-size: 12px">{{ item.IDNO }}</span>
                            </el-option> -->
                        </el-select>
                        <el-select :disabled="saveFlag" v-else-if="item.key==='DEPTNO'" v-model="dtlCol[item.key]"  @change="deptChg" style="width:100%">
                            <el-option v-for="(item,index) in deptArr " :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                        </el-select>
                        <el-date-picker type="date"  v-else-if="item.edcss==='date'" v-model="dtlCol[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>    
                        <el-input-number controls-position="right" v-else-if="item.edcss==='number'"  style="width:100%" v-model="dtlCol[item.key]"></el-input-number> 
                        <el-input :placeholder="item.holder" type="text" v-else  :disabled="item.disabled==='Y'?true:false||saveFlag"  v-model="dtlCol[item.key]"></el-input>
                    </FormItem>
                </span>
            </Form>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="dtlWin=false" style="margin-right:25px;">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-chenggong1"  @click="dtlSave" style="margin-right:10px;">{{ $LANG('1638', '确定') }}</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 引用单据-->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="refWin" :width="dlgWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0732', '分摊关联单据明细') }}</span>
            </div> 
            <div style="border-bottom:2px solid #389;margin-top:-2px;background:white; ">
 
                <el-checkbox border size="small"  @change="selChg"  v-model="selAll" true-label="Y"  false-label="N"><span style="font-size:12px;margin-left:5px;color:#389">{{ $LANG('0263', '全选') }}</span></el-checkbox>
                <el-select v-model="selparam3"  :placeholder="$LANG('1675', '请选择列名')" clearable size="small" style="width:130px;margin-left:15px; ">
                    <span v-for="item in refArr" :key='item.key'>
                        <el-option v-if="item.thide=='N'" :label="item.title" :value="item.key"></el-option>
                    </span>
                </el-select>
                
                <el-input :placeholder="$LANG('1692', '请输入查询值')" ref="refqry" v-model="textparam3" size="small" style="width:340px;height:30px; ">
                    <el-select v-model="oper3"  size="small" slot="prepend" style="width:110px;  ">
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button slot="append" icon="el-icon-search" @click="qryRefData" style="color:#409eff"></el-button>
                </el-input>  
                <el-button @click="cfmSave" style="margin-left:15px" icon="iconfont icon-chenggong1" type="primary" size="mini">{{ $LANG('0893', '确定选择') }}</el-button>
            </div>
            <div style="height:89vh;overflow-y:auto">
                <el-table  :data="refData" 
                        border                            
                        disabled-hover
                        :cell-style="{padding:'2px'}"
                        style="overflow:auto;margin-top:1px;"
                        size="small"
                        :min-height="200" 
                        class="custom-table-border"
                        :row-key="getRefKey"  
                        ref="refjoin" 
                        highlight-current-row>
                    <el-table-column type="index" width="60" :label="$LANG('0310', '序号')" fixed ></el-table-column>
                    <span v-for="(item,index ) in refArr" :key="index">
                        <el-table-column  v-if="item.thide==='N' &&item.edcss!=='checkbox' "
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"                                  
                            sortable
                            :min-width="item.width">
                        </el-table-column>
                        <el-table-column  v-if="item.edcss=='checkbox' "
                            :prop="item.key"
                            :label="item.title"
                            :align="item.align"                                  
                            width="80">
                            <template slot-scope="scope">
                                <el-checkbox  true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                            </template>
                        </el-table-column> 
                    </span>
                </el-table>
            </div>
        </el-dialog>
        <!-- 上传图片-->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="imgWin" width="1200" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0513', '上传图片') }}</span>
            </div> 
            <div style="line-height:30px;border-bottom:2px solid #389;margin-top:5px;background:white"><i class="iconfont icon-xinxi" style="margin-right:4px"></i>{{ $LANG('1918', '最多上传6张图片(可以是图片格式或PDF格式）') }}</div>
            <div style="display:flex;margin-top:15px;" >
 
                <div style="display:flex;margin-left:30px;height:440px;flex-wrap:wrap"  >
                    <div v-if="FILEPATH" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                        <div v-if="FILEPATH &&FILEPATH.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div>
                        <el-image v-else fit="fill" :preview-src-list="[FILEPATH]" style="width:200px;height:150px;" :src="FILEPATH">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <!-- <i class="el-icon-picture-outline" style="font-size:100px"></i> -->
                                <span style="color:red;font-weight:700;font-size:14px">{{ $LANG('1640', '图片未上传') }}</span>
                            </div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link :disabled="saveFlag" :underline="false" @click="imgDel(0)"><Icon type="md-close" /> {{ $LANG('0131', '删除') }}</el-link>
                            <el-link :underline="false" @click="imgPreview( FILEPATH)"><Icon type="ios-search" /> {{ $LANG('0141', '预览') }}</el-link>
                        </div>
                    </div>
                    <div v-if="FILEPATH2" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;"> 
                        <div v-if="FILEPATH2 &&FILEPATH2.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH2" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div> 
                        <el-image v-else fit="fill" :preview-src-list="[FILEPATH2]" style="width:200px;height:150px;" :src="FILEPATH2">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">{{ $LANG('1640', '图片未上传') }}</span>
                            </div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link :disabled="saveFlag" :underline="false" @click="imgDel(1) "><Icon type="md-close" /> {{ $LANG('0131', '删除') }}</el-link>
                            <el-link :underline="false" @click="imgPreview( FILEPATH2)"><Icon type="ios-search" /> {{ $LANG('0141', '预览') }}</el-link>
                        </div>
                    </div>
                    <div v-if="FILEPATH3" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                        <div v-if="FILEPATH3 &&FILEPATH3.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH3" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div> 
                        <el-image v-else fit="fill" :preview-src-list="[FILEPATH3]" style="width:200px;height:150px;" :src="FILEPATH3">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">{{ $LANG('1640', '图片未上传') }}</span>
                            </div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link :disabled="saveFlag" :underline="false" @click="imgDel(2) "><Icon type="md-close" /> {{ $LANG('0131', '删除') }}</el-link>
                            <el-link :underline="false" @click="imgPreview( FILEPATH3)"><Icon type="ios-search" /> {{ $LANG('0141', '预览') }}</el-link>
                        </div>
                    </div>
                    <div v-if="FILEPATH4" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                        <div v-if="FILEPATH4 &&FILEPATH4.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH4" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div> 
                        <el-image v-else fit="fill" :preview-src-list="[FILEPATH4]" style="width:200px;height:150px;" :src="FILEPATH4">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">{{ $LANG('1640', '图片未上传') }}</span>
                            </div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link :disabled="saveFlag" :underline="false" @click="imgDel(3) "><Icon type="md-close" /> {{ $LANG('0131', '删除') }}</el-link>
                            <el-link :underline="false" @click="imgPreview( FILEPATH4)"><Icon type="ios-search" /> {{ $LANG('0141', '预览') }}</el-link>
                        </div>
                    </div>
                    <div v-if="FILEPATH5" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                        <div v-if="FILEPATH5 &&FILEPATH5.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH5" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div> 
                        <el-image v-else fit="fill" :preview-src-list="[FILEPATH5]" style="width:200px;height:150px;" :src="FILEPATH5">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">{{ $LANG('1640', '图片未上传') }}</span>
                            </div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link :disabled="saveFlag" :underline="false" @click="imgDel(4) "><Icon type="md-close" /> {{ $LANG('0131', '删除') }}</el-link>
                            <el-link :underline="false" @click="imgPreview( FILEPATH5)"><Icon type="ios-search" /> {{ $LANG('0141', '预览') }}</el-link>
                        </div>
                    </div>
                    <div v-if="FILEPATH6" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                        <div v-if="FILEPATH6 &&FILEPATH6.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH6" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div> 
                        <el-image v-else fit="fill" :preview-src-list="[FILEPATH6]" style="width:200px;height:150px;" :src="FILEPATH6">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">{{ $LANG('1640', '图片未上传') }}</span>
                            </div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link :disabled="saveFlag" :underline="false" @click="imgDel(5) "><Icon type="md-close" /> {{ $LANG('0131', '删除') }}</el-link>
                            <el-link :underline="false" @click="imgPreview( FILEPATH6)"><Icon type="ios-search" /> {{ $LANG('0141', '预览') }}</el-link>
                        </div>
                    </div>
                </div> 
            </div>
        </el-dialog>
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">{{ $LANG('2052', '正在上传中') }}...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
        <el-dialog v-dialogDrag :visible.sync="showViewer" width="800px" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0141', '预览') }}</span>
            </div>
            <el-image fit="scale-down"  style=" margin:5px auto;height:500px;width:100% " :src="listurl"></el-image>
        </el-dialog>
        <!-- 链接图片预览 -->
        <el-dialog v-dialogDrag :visible.sync="linkWin" width="1200px" append-to-body :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0141', '预览') }}</span>
            </div>
            <div style="display:flex;width:1150px;flex-wrap:wrap">
                <div v-for="(item,index) in linkArr" :key="index" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px; ">    
                    <div v-if="item &&item.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                        <iframe :src="item" frameborder="0" style="width: 100%; height: 100%"></iframe>
                    </div>
                    <el-image v-else fit="fill" :preview-src-list="[item]" style="width:200px;height:150px;" :src="item"></el-image>
                    <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                        <el-link   :underline="false" @click="downFile(item) "><i class="iconfont icon-xiazai" style="font-size:12px"> {{ $LANG('0129', '下载') }}</i> </el-link>
                        <el-link :underline="false" @click="imgPreview( item)"><i class="iconfont icon-chakan1" style="font-size:12px"> {{ $LANG('0141', '预览') }}</i></el-link>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- 分摊费用 -->
        <el-dialog v-dialogDrag :visible.sync="disWin" width="450px" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0607', '分摊方式') }}</span>
            </div>
            <div style="display:flex">
                <div style="width:100px;line-height:30px">{{ $LANG('0607', '分摊方式') }}</div>
                <el-select size="middle" v-model="feeMth" style="width:280px">
                    <el-option v-for="(item,index) in feeArr" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                </el-select>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:20px ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="disWin=false" style="margin-right:25px;">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-chenggong1"  @click="feeSave" style="margin-right:10px;">{{ $LANG('1638', '确定') }}</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 记账 -->
        <el-dialog v-dialogDrag :visible.sync="accWin" width="1220px" append-to-body :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1337', '选择记账费用') }}</span>
            </div>
            <div style="height:30px;line-height:30px;background:#f1f2f3;color:red;border-left:3px solid #389;padding-left:5px">
                 {{ $LANG('2087', '提示：当费用记录已记账后，则不再显示') }}
            </div>
            <div style="height:30px;line-height:30px;background:#fff; ">
                <el-checkbox border size="small"  @change="chkSel"  v-model="v_all" true-label="Y"  false-label="N"><span style="font-size:12px;margin-left:5px;color:#389">{{ $LANG('0263', '全选') }}</span></el-checkbox>
            </div>
            <div style="display:flex;overflow-y:auto;max-height:88vh;width:100%">
                <div v-if="stepFlag">
                    <el-table  :data="bankData" 
                            border                            
                            disabled-hover
                            :cell-style="{padding:'2px'}"
                            style="overflow:auto;margin-top:1px; width:1200px"
                            size="small"
                            :height="300" 
                            :row-key="getDtlKey"  
                            class="custom-table-border"
                            show-summary
                            :summary-method="getSummary"
                            ref="bankref" 
                            highlight-current-row>
                        <el-table-column type="index" :label="$LANG('0310', '序号')" width="60" fixed></el-table-column>
                        <span v-for="(item,index ) in dtlArr" :key="index">
                            <el-table-column  v-if="item.thide==='N' &&item.edcss!=='checkbox' "
                                :prop="item.key"
                                :label="item.title"
                                show-overflow-tooltip
                                :align="item.align"                                  
                                sortable
                                :min-width="item.width">
                            </el-table-column> 
                            <el-table-column  v-if="item.edcss=='checkbox'||item.key=='SEL' "
                                :prop="item.key"
                                :label="item.title"
                                :align="item.align"                                  
                                width="80">
                                <template slot-scope="scope">
                                    <el-checkbox  :disabled="item.key!=='SEL'" true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                                </template>
                            </el-table-column>
                        </span>
                    </el-table>  
                </div>
                <span v-if="!stepFlag">
                    <bank-day ref="refbank" @child-save="finSave" @child-exit="finExit"></bank-day>
                </span>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:20px ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="accWin=false" style="margin-right:25px;">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-xiayiyehouyiye"  @click="nextStep" style="margin-right:10px;">{{ $LANG('0422', '下一步') }}</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 明细表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="dayWin" :width="dlgWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1106', '日记账明细') }} </span>
            </div> 
            <div style="height:85vh;overflow-y:auto" >
                <tmpl-bank ref="refday"></tmpl-bank>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0059', '报表参数') }}</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog> 
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="dlgWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
        </div>
    </div>  
</template>
<script>
import bankDay from './inv_bankday.vue' 
import tmplBank from './tmpl_bankday.vue'
import { getTabColOrData,getBaseData } from '../../api/user';
import {getDate, getDate2} from '../../api/Select' 
import FileSaver from 'file-saver'
import repWin from '../datamgt/repWin.vue' 
import { KeyValuePair } from 'gojs';
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
//局部注册
export default {
    name:"chekc_payable",
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '434494',
            fieldIdseq: '434494',
            fieldLstseq: '2',
            mainColumnKey: 'tabArr',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'tableRef',
            lockedFieldKeys: ['SEL'],
            syncMainColumnSettings: true,
        })
    ],
    data () {
        return {
            dataCount:0,
            pageSize:50,
            current:1,
            v_all:'N',
            v_loading:false,
            supData:[],
            pageList: [50,500,1000],  
 
            stepFlag:true,
            dayWin:false,
            feeMth:'',
            v_empno:'',
            linkWin:false,
            bankData:[],
            feeArr:[],
            disWin:false,
            FILEPATH:'',
            FILEPATH2:'',
            FILEPATH3:'',
            FILEPATH4:'',
            FILEPATH5:'',
            FILEPATH6:'',
            v_idseq:'',
            imgData:[],
            notAcc:'C',
       
            Accept: "png,jpg,jpeg,gif,pdf", //上传文件格式限制
            videoUploadPercent:0,
            videoFlag:false,
            uploadData:{}, //上传数据
            imgWin:false,
            selAll:'N',
            refData:[],
            refWin:false,
            billType:'',
            dtlWin:false,
            dtlCol:{},
            loading:false,
            addWin:false,
            operArr:[],
            addFlag:'create',
            saveFlag:false,
            promptWin:false,
            prompt:'',
            stfgCss:'',
            stfgColor:'',
            oper:'like',
            oper2:'like',
            v_title:'',
            textparam2:'',
            selparam:'DTTM',
            oper3:'like',
            selparam3:'IDNO',
            textparam3:'',
            disabled:false, //新增权限制
            textparam:'',
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            formCol: {},
            tabData:[], //表数据
            tabArr:[], //表列
            dtlArr:[],
            dtlData:[],
            listArr:[],
            listData:[],
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getTableRecMany' , 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            comboArr:[],
            notNull:[],
            notDtl:[],
            delArr:[],
            ruleValidate:{},
            dtlValidate:{},
            dtlFlag:'create',
            rowIndex:'',
            empArr:[],
            v_stfg:'',
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            deptArr:[],
            disArr:[],
            tyArr:[],
            refArr:[],
            v_view:'',
            options:[],
            v_type:'',
            delData:[],
            subArr:[],
            listurl:'',
            showViewer:false,
            accWin:false,
            linkArr:[],
            repDlg:false,
            v_rowRec:{},
            v_idno:'',
            hapBool:false,
            v_replist:[],
            repArr:[],
            repWin:false,
            repUrl:'',
            v_commit:true,
            v_data:[],
            v_row:{},
            supCol:[],
            v_supnm:'#',
            v_index:0,
            allList:[],
            vueCol:[],
            initCol:[],
            pageIndex:1,
            loadingInstance: null,
            columnHiddenOption: {
                // default hidden column keys
                defaultHiddenColumnKeys: [],
            },
            rowStyleOption: {
                clickHighlight: true,                
            }, 
            startRowIndex: 0,
            footerData:[], 
            cellStyleOption: {
                bodyCellClass: ({ row, column, rowIndex }) => {
                    return "table-body-cell-class1"      
                },
                headerCellClass: ({column, rowIndex }) => {
                    if (column.field=='#'){
                        return "table-head-cell-class2"
                    }else{
                        return "table-head-cell-class" 
                    }
                },
                footerCellClass: ({ row, column, rowIndex }) => {
                    return "table-foot-cell-class";
                },
            },
            virtualScrollOption: { enable: false },
            v_inputrow:{},
            v_sort:'asc',
        }
    },
    mounted () { 
        
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','227450','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
        //用户表单新增、编辑、审核、作废权限  
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','434494','v_sys_user_priv',' and issel=\'Y\'').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                if (res.result.length>0){
                    let row =res.result[0]
                    if (row.ISADD==='N'){ //新增
                        this.addBool=true
                    }if (row.ISUPD==='N'){ //修改
                        this.editBool=true
                    }if (row.ISDEL==='N'){ //删除
                        this.delBool=true
                    }if (row.ISCFM==='N'){ //审核
                        this.cfmBool=true
                    }if (row.ISCANCEL==='N'){ //作废
                        this.cancelBool=true
                    }
                }
            }
        })  
 
        //操作符
        getBaseData(this.v_formurl,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        getBaseData(this.v_formurl,'corpid',this.v_corpid,'','','V_FEE_EMP','').then(res=>{
            this.empArr =res.result
        })
        getBaseData(this.v_formurl,'corpid',this.v_corpid,'','','hr_frame','').then(res=>{
            this.deptArr =res.result
        })
        getBaseData(this.v_formurl,'corpid',this.v_corpid,'','','V_SUBJECT_COMBO','').then(res=>{
            this.subArr =res.result
            this.options =res.result
        })
        getBaseData(this.v_formurl,'PARENTNO','228806','','','v_sys_base','').then(res=>{
            this.disArr =res.result
        })
        getBaseData(this.v_formurl,'PARENTNO','230797','','','v_sys_base','').then(res=>{
            this.feeArr =res.result
        })
        getBaseData(this.v_formurl,'PARENTNO','228812','','','v_sys_base','').then(res=>{
            this.tyArr =res.result
        })
        this.comSelect()
        //查询数据
        this.chkChg(this.notAcc)
    },
    computed: {
        dlgWidth: function() {
            return (window.innerWidth - 100) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 155) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 630) + 'px';
        },
        subHeight: function() {
            return (window.innerHeight - 82) + 'px';
        },
    },
    components: {
        bankDay,
        tmplBank,
        repWin,
        VeColumnConfigDialog,
    },
    destroyed() {
        this.loadingInstance.destroy()
    },
    created () {       
        if (this.v_username){ 
            this.loadingInstance = this.$veLoading({
                target: document.querySelector("#check_pay"),
                name: "wave",
            })
            this.getTabField() //表列字段
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
        
    },
    methods: {

        inputChg(e,column){
            this.v_inputrow[column]=e.target.value
            this.v_row[column] =e.target.value
        },
        sortChange(params){
            let v_key=params.key ,v_edcss=''
            if (this.v_sort =='asc'){
                this.v_sort ='desc'
            }else if (this.v_sort =='desc'){
                this.v_sort ='asc'
            } 
            this.tabArr.some(item=>{
                if (item['key']==v_key){
                    v_edcss =item['edcss']
                }
            })
            this.tabData.sort((a, b) => {
                if (v_edcss =='number' ){
                    if (this.v_sort =='asc'){ //a == null ? -1 : b == null ? 1 : 0
                        return a[v_key] == null ? -1 : b[v_key] == null ? 1 :   a[v_key] -b[v_key]
                    }else if (this.v_sort =='desc'){
                        return b[v_key] == null ? -1 : a[v_key] == null ? 1 :  b[v_key] -a[v_key]
                    }else{
                        return 0
                    }
                }else{
                    let nameA = a[v_key]?a[v_key].toUpperCase():a[v_key]  
                    let nameB = b[v_key]?b[v_key].toUpperCase():b[v_key]     
                    if (this.v_sort =='asc'){
                        return nameA == null ? -1 : nameB== null ? 1 :  nameA > nameB ? -1 : 1
                    }else{
                        return nameA == null ? 1 : nameB== null ? -1 : nameA > nameB ? 1 : -1
                    }
                }
            })
        },
        //页号改变
        pageNumberChange(pageIndex) {
            this.pageIndex = pageIndex
            this.changePage(pageIndex)
        },
        pageSizeChange(pageSize) {
            this.pageIndex = 1
            this.pageSize = pageSize
            this.changePage(this.pageIndex)
        },
 
        getSupList(empno,val){
            this.supData=[]
            this.v_loading =true
            let v_cond ='',t_cond=''
            if (empno ){   
                v_cond=' and EMPNM like \'%'+empno+'%\'  ' 
            } 
            if (val=='C'){
                t_cond = ' SELECT EMPNM ,MAX(IDSEQ) IDSEQ FROM V_FIN_FEEDTL_SUP WHERE CORPID='+this.v_corpid+v_cond+' and EMPNM IS NOT NULL AND PAYIDNO IS   NULL GROUP BY EMPNM '
            }else if (val=='C2'){
                t_cond = ' SELECT EMPNM ,MAX(IDSEQ) IDSEQ FROM V_FIN_FEEDTL_SUP WHERE CORPID='+this.v_corpid+v_cond+' and EMPNM IS NOT NULL AND PAYIDNO IS  NULL  AND STFG!=\'Y\' GROUP BY EMPNM '
            }else if (val=='C3'){
                t_cond = ' SELECT EMPNM ,MAX(IDSEQ) IDSEQ FROM V_FIN_FEEDTL_SUP WHERE CORPID='+this.v_corpid+v_cond+' and EMPNM IS NOT NULL AND PAYIDNO IS  NULL  AND STFG=\'Y\' GROUP BY EMPNM '
            }else if (val=='Y'){
                t_cond = ' SELECT EMPNM ,MAX(IDSEQ) IDSEQ  FROM V_FIN_FEEDTL_SUP WHERE CORPID='+this.v_corpid+v_cond+' and EMPNM IS NOT NULL AND PAYIDNO IS  NOT NULL GROUP BY EMPNM '
            }else if (val=='NN'){// 已支付 未送货 未开票
                t_cond = ' SELECT EMPNM ,MAX(IDSEQ) IDSEQ  FROM V_FIN_FEEDTL_SUP WHERE CORPID='+this.v_corpid+v_cond+' and EMPNM IS NOT NULL AND PAYIDNO IS  NOT NULL and idseq in (select idseq from v_fin_fee where finvno is null and stkno is null group by idseq) GROUP BY EMPNM '
            }else if (val=='YN'){ // 已支付 已送货 未开票
                t_cond = ' SELECT EMPNM ,MAX(IDSEQ) IDSEQ  FROM V_FIN_FEEDTL_SUP WHERE CORPID='+this.v_corpid+v_cond+' and EMPNM IS NOT NULL AND PAYIDNO IS  NOT NULL and idseq in (select idseq from v_fin_fee where finvno is null and stkno is not null group by idseq) GROUP BY EMPNM '
            }else{
                t_cond = ' SELECT EMPNM ,MAX(IDSEQ) IDSEQ  FROM V_FIN_FEEDTL_SUP WHERE CORPID='+this.v_corpid+v_cond+' AND EMPNM IS NOT NULL   GROUP BY EMPNM '
            }
            
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getFreeData',
                data: { p_cond: t_cond },
            }).then(res=>{  
                if (res.code=='200'){
                    this.supData =res.result

                    if (this.supData.length>0){
                        //this.$refs['refsup'].setCurrentRow(this.supData[this.v_index])
                        this.v_supnm =this.supData[0]['EMPNM']
                    }
                    if (empno && empno!==''){
                        this.getSupChk(val,this.v_supnm)
                    }else{
                        this.getSupChk(val,'')
                    }
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                }
                this.v_loading =false 
            }) 
        },
        getSupChk(val,empnm){ 
            let v_cond =''
            if (empnm && empnm !=='') {
                v_cond =' and empno=\''+empnm+'\''
            }
            if (val=='C'){
                this.getFeeList(v_cond +' and idseq in (select idseq from V_FIN_FEEDTL_SUP where  payidno is null)')
            }else if (val=='C2'){
                this.getFeeList(v_cond +' and idseq in (select idseq from V_FIN_FEEDTL_SUP where  payidno is null AND STFG!=\'Y\')')
            }else if (val=='C3'){
                this.getFeeList(v_cond +' and idseq in (select idseq from V_FIN_FEEDTL_SUP where  payidno is null AND STFG=\'Y\')')
            }else if (val=='Y'){
                this.getFeeList(v_cond +' and idseq in (select idseq from V_FIN_FEEDTL_SUP where stfg=\'Y\' and payidno is not null and payidno!=\'PAYOK\')')
            }else if (val=='YN'){
                this.getFeeList(v_cond +' and stkno is not null and finvno is null and idseq in (select idseq from V_FIN_FEEDTL_SUP where stfg=\'Y\' and payidno is not null and payidno!=\'PAYOK\')')
            }else if (val=='NN'){
                this.getFeeList(v_cond +' and stkno is null and finvno is null and idseq in (select idseq from V_FIN_FEEDTL_SUP where stfg=\'Y\' and payidno is not null and payidno!=\'PAYOK\')')
            } else {
                this.getFeeList(v_cond)
            } 
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
        },
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.getTabList('')
        } ,
        //字段查询
        inputQry(){
            let v_cond ='' , v_oper='=' ,v_oper2='like' ,v_edcss=''
            Object.keys(this.v_row).filter(item=>item.indexOf('#OPER')<0).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabArr.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (this.v_row[`#OPER`+item]){
                        v_oper =this.v_row[`#OPER`+item]
                    }
                    if (this.v_row[`#OPER`+item]){
                        v_oper2 =this.v_row[`#OPER`+item]
                    }     
                    if (v_edcss =='number' ){
                        v_cond =v_cond +' and '+item+ v_oper +  this.v_row[item] 
                    }else if ( v_edcss=='date'){
                        v_cond =v_cond +' and '+item+ v_oper +'\''+this.v_row[item] +'\''
                    }else{
                        if (v_oper2 =='='){
                            v_cond =v_cond +' and lower('+item+') = \''+ (this.v_row[item]).toLowerCase().trim()+'\''  
                        }else{
                            v_cond =v_cond +' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                        }
                    }
                }
            })
            this.getTabList(v_cond)
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt =this.$LANG('1678', '请选择报表')
            }else{
                this.repWin =true
                this.repDlg =false
                if (this.v_rowRec['REFIDTY']=='STK'){ //以发票为主线
                    this.repUrl =this.$store.state.repUrl+ 'rep_payable.cpt'+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO']+'&p_userid='+this.v_username+getDate('full')
                }else if (this.v_rowRec['REFIDTY']=='OUT'){ //以发票为主线
                    this.repUrl =this.$store.state.repUrl+ 'out_payable.cpt'+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO']+'&p_userid='+this.v_username+getDate('full')
                }else{
                    this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO']+'&p_userid='+this.v_username+getDate('full')
                }
    
            }
        },
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
            this.v_rowRec =JSON.parse(JSON.stringify(row))
        },
 
        downFile(item){
            let blob =new Blob([item],{type:'text/plain;charset=utf-8'})
            const arr_name=item.split("/")
            const file_name=arr_name[arr_name.length-1] //获取文件名
            FileSaver.saveAs(item,file_name) 
        },
        //链接详情
        seeLink(val){
            this.linkWin =true
            this.linkArr =val.split(',').filter(item=>{
                return item !==''
            })
        },
        chkChg(val){
            this.getSupList('',val)
            if (val =='ALL'){
                this.v_title ='(' + this.$LANG('0040', '所有记录') + ')'
            }else if (val =='C'){
                this.v_title ='(' + this.$LANG('2041', '待支付-所有') + ')'
            }else if (val =='C2'){
                this.v_title ='(' + this.$LANG('1538', '待支付-报销未审核') + ')'
            }else if (val =='C3'){
                this.v_title ='(' + this.$LANG('1537', '待支付-报销已审核') + ')'
            }else if (val =='NN'){
                this.v_title ='(' + this.$LANG('1535', '已支付未送货未开票') + ')'
            }else if (val =='YN'){
                this.v_title ='(' + this.$LANG('1535', '已支付未送货未开票') + ')'
            }else if (val =='Y'){
                this.v_title ='(' + this.$LANG('1975', '已完结') + ')'
            }
 
        },
        seeDay(idseq){
            this.dayWin =true
            this.$nextTick(()=>{
                this.$refs['refday'].initData(idseq)
            })
        },
        finExit(){
            this.accWin =false
            this.stepFlag =true
        },
        finSave(idseq){
            this.accWin =false
            this.stepFlag =true
            this.getDtlData(this.v_idseq)
        },
        //记账
        accRec(){
            this.v_data=[]
            this.v_all ='N'
            this.tabData.forEach(item=>{
                if (item['SEL']=='Y'){
                    this.v_data.push(JSON.parse(JSON.stringify(item)))
                }
            })
            if (this.v_data.length ==0){
                this.promptWin =true
                this.prompt =this.$LANG('1782', '请选择需要记账的单据')
            }else{
                this.accWin =true
                this.bankData=[]
                //选择记录
                this.v_data.forEach(item=>{
                    this.$axios({   
                        method: 'post',
                        url:'xuper_auth/getBaseData',
                        data: {p_key:'idseq', p_value:item['IDSEQ'], p_cond: ' order by lstseq' ,p_table:'V_FIN_FEEDTL'},
                    }).then(res=>{ 
                        res.result.forEach(it=>{  
                            if (!it['PAYIDNO']){
                                this.bankData.push(it)
                            }
                        })
                        this.$nextTick(()=>{
                            this.$refs['bankref'].doLayout()
                        })
                        
                    })
                })
            } 
        },
        filterableData(val){
            let result =[]
            if (val ){
                this.options.forEach(item=>{
                    if (item['IDNO'].indexOf(val)>-1||item['CNAME'].indexOf(val)>-1){
                        result.push(item)
                    } 
                })
                this.subArr =result
            }else{
                this.subArr =this.options
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.pageSize;
            var _end = index * this.pageSize
            this.pageIndex =index
            this.tabData = this.allList.slice(_start,_end)
            this.getFootSum()
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.pageSize){
                this.tabData = this.allList          
            }else{
                this.tabData =this.allList.slice(0,this.pageSize) //返回选定元素的子数组，不包含结尾元素            
            }
            this.getFootSum()
        },
        getFootSum(){ //TTLAMT'||column.property==='OKAMT'||column.property==='NOAMT'
            let v_foot ={}
            const targetKeys = ['TTLAMT', 'OKAMT','NOAMT' ]
            // 初始化累加器对象
            const initialAcc = targetKeys.reduce((acc, key) => {
                acc[key] = 0
                return acc
            }, {})
            // 单次 reduce 计算所有总和
            const totals = this.tabData.reduce((acc, cur) => {
                targetKeys.forEach(key => {
                    // 累加当前 key 的值，处理 undefined/null 情况
                    acc[key] += Number(cur[key]) || 0
                });
                return acc
            }, initialAcc)
            // 格式化并赋值
            targetKeys.forEach(key => {
                const val = totals[key];
                v_foot[key] = val > 0 ? val.toLocaleString() : '';
            })
            let v_obj =Object.assign({
                    rowKey: 0,
                    index: "合计",
                }, v_foot)
            this.footerData =[  v_obj ]
        } , 
        //图片预览
        imgPreview(path){
            if (path &&path.lastIndexOf('.pdf')>-1){
                let routeUrl = this.$router.resolve({
                    path: '/fullPreview',
                    query: {fileUrl: path},
                });
                window.open(routeUrl.href, '_blank');
            }else{
                this.showViewer=true
                this.listurl=path
            }
        },
        //图片删除，操作数组
        imgDel( index){
            this.$confirm(this.$LANG('1594', '你确定要删除此图片吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                if (index==0){
                    this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH:''}) )
                    this.FILEPATH =''
                }else if (index==1){
                    this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH2:''}) )
                    this.FILEPATH2=''
                }else if (index==2){
                    this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH3:''}) )
                    this.FILEPATH3=''
                }else if (index==3){
                    this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH4:''}) )
                    this.FILEPATH4=''
                }else if (index==4){
                    this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH5:''}) )
                    this.FILEPATH5=''
                }else if (index==5){
                    this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH6:''}) )
                    this.FILEPATH6=''
                }
                
                               
            }).catch(()=>{})
        },
 
        upImg(row,index){
            this.imgWin =true
            this.rowIndex =index
            this.FILEPATH =row['IMGPATH']
            this.FILEPATH2 =row['IMGPATH2']
            this.FILEPATH3 =row['IMGPATH3']
            this.FILEPATH4 =row['IMGPATH4']
            this.FILEPATH5 =row['IMGPATH5']
            this.FILEPATH6 =row['IMGPATH6']
            this.dtlCol=JSON.parse(JSON.stringify(row))
        },
        //确定选择 所关联记录
        cfmSave(){
            let arr =[]
            this.refData.forEach(item=>{
                if (item['SEL']=='Y'){
                    let obj ={}
                    let v_pkseq =item['IDSEQ']+'-'+item['LSTSEQ']
                    Object.assign(obj,{SKUNO:item['SKUNO'],REFTYNM:item['REFTYNM'],REFIDNO:item['IDNO'],REFDTTM:item['ORDDTTM'],MATNO:item['MATNO'],MATNM:item['MATNM'],MATDESC:item['MATDESC'],QTY:item['QTY'],PRC:item['PRC'],BOXCUBE:item['BOXCUBE'],REFIDSEQ:item['IDSEQ'],REFLSTSEQ:item['LSTSEQ']})
                    let bool =true
                    //判断是否存在添加 
                    this.listData.some(item=>{
                        if (item['REFIDSEQ']+'-'+item['REFLSTSEQ'] ==v_pkseq){
                            bool =false
                        }
                    })
                    if (bool){
                        arr.push(obj)
                    }
                }
            })
            //console.log(JSON.stringify(arr))
            if (arr.length >0){
                arr.forEach(item=>{
                    this.listData.push(item)
                }) 
            }
            this.refWin=false
            this.$nextTick(() => { //有固定列时 查询后重新布局
                this.$refs.listref.doLayout();
            })
        },
        chkSel(){
            if(this.v_all =='Y'){
                this.bankData.forEach(item=>{
                    Object.assign(item ,{SEL:'Y'})
                })
            }else{
                this.bankData.forEach(item=>{
                    Object.assign(item ,{SEL:'N'})
                })
            }

        },
        //
        selectChg(key){
            if (key =='HAPPEN'){
                
                if (this.formCol['HAPPEN']=='407503'){
                    this.hapBool =true
                }else{
                    this.hapBool =false
                }
                if (this.formCol['FINVNO']){
                    this.formCol['FINVNO']=''
                }
            }
        },
        selChg(){
            if(this.selAll =='Y'){
                this.refData.forEach(item=>{
                    Object.assign(item ,{SEL:'Y'})
                })
            }else{
                this.refData.forEach(item=>{
                    Object.assign(item ,{SEL:'N'})
                })
            }
        },
        //对指定列进行合计
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]=this.$LANG('0280', '合计')
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='CHKAMT'||column.property==='ACTPAY'){
                    let v_sum =values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) )
                        }else{
                            return prev
                        }
                    },'')
                    if (v_sum){
                        sums[index] =v_sum.toLocaleString()
                    }else{
                        sums[index]=''
                    }
                }
            })
            return sums
        },
        getListSum(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]=this.$LANG('0280', '合计')
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='DISAMT'||column.property==='AMT'|| column.property==='QTY'){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(1)
                        }else{
                            return prev
                        }
                    },'')
                }
            })
            return sums
        },
 
        deptChg(val){
            this.deptArr.some(item=>{
                if (item['CODE']==val){
                    Object.assign(this.dtlCol,{DEPTNM:item['CNAME']})
                }
            })
        },
        disChg(val){
            this.disArr.some(item=>{
                if (item['CODE']==val){
                    Object.assign(this.dtlCol,{DISTYNM:item['CNAME']})
                }
            })
        },
        acChg(val){
            this.subArr.some(item=>{
                if (item['IDNO']==val){
                    Object.assign(this.dtlCol,{ACNM:item['CNAME']})
                }
            })
        },
 
        disFee(){
            this.disWin =true
        },
        //下一步
        nextStep(){
            let selArr =[]
            this.bankData.forEach(item=>{
                let obj={}
                if (item['SEL']=='Y'){
                    Object.assign(obj,item,{IDSEQ:'',LSTSEQ:'',REFIDSEQ:item['IDSEQ'],REFLSTSEQ:item['LSTSEQ']  })
                    selArr.push(obj)
                }
            })
            if (selArr.length>0){
                this.stepFlag =false
                this.$nextTick(()=>{
                    this.$refs['refbank']['v_acno']='15911'
                    this.$refs['refbank']['v_word']='4260'
                    this.$refs['refbank']['v_orgnm']=this.formCol['EMPNO']
                    this.$refs['refbank']['spFlag'] =false
                    this.$refs['refbank'].addRec()
                    this.$refs['refbank'].feeData =selArr
                })
            }else{
                this.promptWin =true
                this.prompt =this.$LANG('1783', '请选择需要记账的记录')
            }
        },
        //分摊费用
        feeSave(){
            if (!this.feeMth ){
                this.promptWin =true
                this.prompt =this.$LANG('1727', '请选择分摊方式')
            }else{
                let amt =0 ,v_mth =''
                //获取 方式中文名称
                this.feeArr.some(item=>{
                    if (item['CODE']==this.feeMth){
                        v_mth =item['CNAME']
                    }
                })
                this.dtlData.forEach(item=>{
                    if (item['ISOK']=='Y'){
                        amt =Number(amt)+Number(item['CHKAMT'])
                    }
                })           
                if(amt>0){
                    //默认按金额比例分摊 费用
                    let sum =0  //总金额
                    if (this.feeMth=='230800') { //按价格
                        this.listData.forEach(item=>{
                            sum=Number(sum)+Number(item['PRC'])
                        })
                        if (sum >0){
                            this.listData.forEach((item,index)=>{
                                if (Number(item['PRC'])>0 ){
                                    let v_disamt =Number(amt *Number(item['PRC']/Number(sum))).toFixed(2)
                                    let v_amt = (v_disamt/Number(item['QTY'])).toFixed(2)
                                    this.listData.splice(index,1,  Object.assign(item ,{DISMTH:v_mth,DISAMT:v_disamt,AMT:v_amt}) )
                                }
                            })
                        }
                    }else if (this.feeMth=='230801') { //按体积
                        this.listData.forEach(item=>{
                            sum=Number(sum)+Number(item['BOXCUBE']*item['QTY'])
                        })
                        if (sum >0){
                            this.listData.forEach((item,index)=>{
                                if (Number(item['BOXCUBE'])>0 ){
                                    let v_disamt =Number(amt *Number(item['BOXCUBE']*item['QTY']/Number(sum))).toFixed(2)
                                    let v_amt = (v_disamt/Number(item['QTY'])).toFixed(2)
                                    this.listData.splice(index,1,  Object.assign(item ,{DISMTH:v_mth,DISAMT: v_disamt,AMT:v_amt}) )
                                }
                            })
                        }
                    }else{  //按数量
                        this.listData.forEach(item=>{
                            sum=Number(sum)+Number(item['QTY'])
                        })
                        if (sum >0){
                            this.listData.forEach((item,index)=>{
                                if (Number(item['QTY'])>0 ){
                                    let v_disamt =Number(amt *Number(item['QTY']/Number(sum))).toFixed(2)
                                    let v_amt = (v_disamt/Number(item['QTY'])).toFixed(2)
                                    this.listData.splice(index,1,  Object.assign(item ,{DISMTH:v_mth,DISAMT:v_disamt,AMT:v_amt}) )
                                }
                            })
                        }
                    }
                    this.disWin=false
                }else{
                    this.disWin=false
                    this.promptWin =true
                    this.prompt =this.$LANG('1818', '没有费用需分摊，请核查')
                }
            }
        },
        //关联单据
        addList(){
            if (this.billType){ 
                this.tyArr.some(item=>{
                    if (item['CODE']== this.billType){
                        this.v_view =item['SUBNO']
                        this.v_type =item['CNAME']
                    }
                })
                if (this.v_view){
                    this.refWin =true
                    this.refData=[]
                    getTabColOrData(this.v_url,this.v_view,'','').then((res) => {
                        this.refData =res.result
                        this.$nextTick(() => { //有固定列时 查询后重新布局
                            this.$refs.refjoin.doLayout();
                        })
                    })
                }else{
                    this.promptWin =true
                    this.prompt =this.$LANG('1863', '此单据类型的数据源还未设置')
                }
            }else{
                this.promptWin =true
                this.prompt =this.$LANG('1728', '请选择单据类型')
            }
        },
        qryRefData(){
            let cond_=''
            if (this.selparam3 && this.textparam3){ //列1
                if (this.oper3==='like'){
                    cond_=cond_+' and  '+this.selparam3+'  like  \'%' + this.textparam3+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam3  +this.oper3+' \''+this.textparam3+'\' '
                }
            }
            getTabColOrData(this.v_url,this.v_view,'','','','','','',cond_).then((res) => {
                this.refData =res.result
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.refjoin.doLayout();
                })
            })
        },
        //新增费用
        addDtl(){
            this.dtlFlag='create'
            this.dtlCol={ISOK:'Y',CRCY:'人民币'}
            this.dtlWin =true
        },
        dtlEdit(row ,index){
            this.dtlCol=JSON.parse(JSON.stringify(row))
            this.dtlWin=true
            this.dtlFlag='edit'
            this.rowIndex=index
        } ,
        dtlSave(){
            this.notDtl.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.dtlCol[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=this.$translate.getColTitle(item, this.$store.state.lang)+this.$LANG('2051', '不能为空')
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool) {
                this.dtlWin =false
                if (this.dtlFlag==='edit' ){ //编辑时要替换数组记录
                    this.dtlData.splice(this.rowIndex,1,this.dtlCol)
                }else{
                    this.dtlData.push(this.dtlCol)
                }
            }
            this.$nextTick(() => { //有固定列时 查询后重新布局
                this.$refs.dtlref.doLayout();
            })
        },
        dtlDel(row,index){
            this.$confirm(this.$LANG('1594', '你确定要删除此记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.dtlData.splice(index,1)
                if (row['IDSEQ'] && row['LSTSEQ']){
                    this.delArr.push(row)
                }
            }).catch(()=>{})
        },
        listDel(row,index){
            this.$confirm(this.$LANG('1594', '你确定要删除此记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.listData.splice(index,1)
                if (row['IDSEQ'] && row['LSTSEQ']){
                    this.delData.push(row)
                }
            }).catch(()=>{})
        },
 
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'434494',p_cond:' and lstseq in (1,2,3)' ,p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        supClick(row){
            this.v_index =row.index
            this.v_supnm =row['EMPNM']
            this.getSupChk(this.notAcc ,row['EMPNM'])
        },
        //表行点击事件
        rowClick(row){
            this.v_idseq =row['IDSEQ']
            
            if (row['STFG']==='Y')  {  
                this.stfgColor='color:green'
                this.stfgCss='icon-yishenhe1'
            }else if (row['STFG']==='X')  {  
                this.stfgColor='color:red'
                this.stfgCss='icon-yizuofei'
            }else{
                this.stfgColor='color:gray'
                this.stfgCss='icon-weishenhe3'
            }
        },
        //查询明细数据
        getDtlData(idseq){
            this.dtlData=[]
            getTabColOrData(this.v_url,'V_FIN_FEEDTL','idseq',idseq).then((res) => {
                this.dtlData =res.result  
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.dtlref.doLayout()
                })
            })
        },
        getItmData(idseq){
            this.listData=[]
            getTabColOrData(this.v_url,'V_FIN_FEElist','idseq',idseq).then((res) => {
                this.listData =res.result  
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.listref.doLayout();
                })
            })
        },
        //查询
 
        getTabList(v_cond){
            let cond_= ''//' and empno=\''+this.v_supnm+'\''
 
            if (this.notAcc=='C'){
                cond_=cond_+ ' and idseq in (select idseq from V_FIN_FEEDTL_SUP where   payidno is null)'
            }else if (this.notAcc=='C2'){
                cond_=cond_+ ' and idseq in (select idseq from V_FIN_FEEDTL_SUP where   payidno is null and stfg!=\'Y\')'
            }else if (this.notAcc=='C3'){
                cond_=cond_+ ' and idseq in (select idseq from V_FIN_FEEDTL_SUP where   payidno is null and stfg=\'Y\')'
            }else if (this.notAcc=='Y'){
                cond_=cond_+ ' and idseq in (select idseq from V_FIN_FEEDTL_SUP where stfg=\'Y\' and payidno is not null and payidno!=\'PAYOK\')'
            }else if (this.notAcc=='NN'){
                cond_=cond_+ ' and stkno is null and finvno is null and idseq in (select idseq from V_FIN_FEEDTL_SUP where stfg=\'Y\' and payidno is not null and payidno!=\'PAYOK\')'
            }else if (this.notAcc=='YN'){
                cond_=cond_+ ' and stkno is not null and finvno is null and idseq in (select idseq from V_FIN_FEEDTL_SUP where stfg=\'Y\' and payidno is not null and payidno!=\'PAYOK\')'
            } 
            this.getFeeList( cond_ +v_cond)
        },
        editRec(row,val){
            if (row['STFG']=='Y'||val=='Y'){
                this.saveFlag=true
            }else{
                this.saveFlag=false
            }
            this.v_stfg =row['STFG']
            this.addWin =true
            this.formCol =JSON.parse(JSON.stringify(row))
            this.getDtlData(row['IDSEQ']) 
            this.getItmData(row['IDSEQ'])
            this.delArr =[]
            this.v_commit =true
            if (row['HAPPEN']=='407503'){
                this.hapBool =true
            }else{
                this.hapBool =false
            }
        },
 
 
        //fee 明细
        getFeeList(cond){
            //获取所有产品记录且初始化分页记录  
            this.loadingInstance.show()    
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'', p_value:'',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond ,p_table:'V_FIN_FEE'},
            }).then(res=>{ 
                this.allList =res.result
                this.$nextTick(() => { // 
                    this.loadingInstance.close() 
                })
                this.initPage()
            }) 
        },
 
        getRowKey(row){
            return row.IDSEQ
        },
        getDtlKey(row){
            return row.IDSEQ+'-'+row['LSTSEQ']
        },
        getListKey(row){
            return row.REFIDSEQ+'-'+row['REFLSTSEQ'] 
        },
        getRefKey(row){
            return row.IDSEQ+'-'+row['LSTSEQ'] 
        },
 
        //获取表列字段
        getTabField(){
            let vm =this
            this.tabArr =[]
            this.vueCol =[]
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','434494','lstseq','2','','',' order by sortby,lstseq').then((res) => {
                this.initCol =res.result
                return this.loadInitialFieldSettings().then(() => res)
            }).then(() => {
                const mainFields =this.sortFieldRows(this.initCol)
                for (let k=0; k<mainFields.length; k++){
                    let itcol =mainFields[k]
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(itcol, vm.$store.state.lang),
                        key: itcol.key,
                        align: itcol.align,
                        width: itcol.width,
                        edcss:itcol.EDCSS,
                        thide:itcol.THIDE,
                        fhide:itcol.FHIDE,
                        disabled:itcol.DISABLED,
                        sortable:itcol.SORTABLE,
                    })
                    if (itcol['THIDE']=='N'){
                        let v_obj ={   //向数组的开头 添加序列号
                            field:itcol['key'] ,
                            title: vm.$translate.getColTitle(itcol, vm.$store.state.lang),
                            key: itcol['key']  ,
                            type:itcol.EDCSS=='checkbox'?'check':itcol.EDCSS,
                            align: itcol.align,                                
                            width: Number(itcol.width),
                            thide:itcol.THIDE,
                            fhide:itcol.FHIDE,
                            sortable:false,
                            renderHeaderCell: ({column}, h) => {
                                if (itcol.EDCSS =='date'||itcol.EDCSS =='time') {
                                    return (                              
                                        <div >                   
                                            <div style="margin-top:3px;display:flex;white-space: nowrap;  " >
                                                <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700">{column.title}</el-link>                                            
                                            </div> 
                                            <div style="display:flex">
                                                <select  style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_inputrow[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>                                                    
                                                    <option    value="=" style="height:30px;line-height:30px">=</option>
                                                    <option    value=">" style="height:30px;line-height:30px">&gt;</option>
                                                    <option    value="<" style="height:30px;line-height:30px">&lt;</option>
                                                    <option    value="!=" style="height:30px;line-height:30px">!=</option>
                                                </select>
                                                <el-date-picker v-model={this.v_row[column.key]} value-format="yyyy-MM-dd" size="mini"  placeholder="yyyy-mm-dd" style="width:100%" on-change={()=>this.inputQry() }  ></el-date-picker> 
                                                         
                                            </div>
                                        </div>                                   
                                    )
                                } else{
                                    if (itcol.EDCSS =='number') {
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                                </div>  
                                                <div style="display:flex">
                                                    <select  style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_inputrow[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>
                                                        <option    value="=" style="height:30px;line-height:30px">=</option>
                                                        <option    value=">" style="height:30px;line-height:30px">&gt;</option>
                                                        <option    value="<" style="height:30px;line-height:30px">&lt;</option>
                                                        <option    value="!=" style="height:30px;line-height:30px">!=</option>
                                                    </select>
                                                    <el-input  placeholder="请输入"  disabled={itcol.EDCSS=='image'}  v-model={this.v_row[column.key]}   on-change={()=>this.inputQry() } style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></el-input> 
                                                </div>
                                            </div>                                   
                                        )
                                    }else if (itcol.EDCSS =='checkbox') {
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                                </div>  
                                                <div style="display:flex">
                                                    <el-select  placeholder="请选择"   v-model={this.v_row[column.key]}   on-change={()=>this.inputQry() } style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini">
                                                        <el-option label={this.$LANG('2047', '是')} value="Y"></el-option>
                                                        <el-option label={this.$LANG('2044', '否')} value="N"></el-option>
                                                    </el-select> 
                                                </div>
                                            </div>                                   
                                        )

                                    } else{
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                                </div>  
                                                <div style="display:flex">
                                                    <el-input  placeholder="请输入"  disabled={itcol.EDCSS=='image'||itcol.key=='SEL'}  v-model={this.v_row[column.key]}   on-change={()=>this.inputQry() } style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></el-input> 
                                                </div>
                                            </div>                                   
                                        )
                                    }
                                }
                            },
                            disabled:itcol.DISABLED,
                            ellipsis: { showTitle: true, },
                            renderBodyCell: ({row,column,rowIndex},h) => {
                                let  rowVal =row[itcol['key'] ]
                                if (itcol.key=='SEL' ){
                                    return ( 
                                        <el-checkbox true-label="Y" disabled={row['STFG']!=='Y'} false-label="N" v-model={row['SEL']}  style="width:100%;"   > </el-checkbox>
                                    )
                                } else if (column.key=='STFG') {                         
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('1976', '已审核')}</el-tag> )
                                    }else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('2005', '未审核')}</el-tag> )
                                    }                                          
                                }else if (column.key=='IDNO') { //procShow(scope.row)
                                    return (
                                        <el-link   on-click={()=>{this.repBtn(row)}}  underline={false} ><span style="font-size:13px;border-bottom:1px solid #409eff;font-weight:700">{row[itcol['key']]}</span></el-link> 
                                    )
                                }else if (itcol.EDCSS=='checkbox' ) {                         
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('2047', '是')}</el-tag> )
                                    }else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('2044', '否')}</el-tag> )
                                    }                                          
                                }else{
                                    return row[itcol['key'] ]
                                }
                            },                                
                        }
                        this.vueCol.push(v_obj)
                    }
                }
                // 分组 字段
                let v_rownum ={
                    field: "index",
                    key: "rownum",
                    title: this.$LANG('0310', '序号'),
                    width: 55,
                    align: "left",
                    fixed:"left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row['PAYSRC']=='433336'){
                            return (<span style="color:#1890ff;">
                                {rowIndex + this.startRowIndex + 1}
                                <span style="margin-left:2px;font-size:12px;width:20px;height:20px;background:red;color:white;padding-left:2px">{this.$LANG('0832', '代')}</span>
                            </span> )
                        }else{
                            return (<span style="color:#1890ff;">
                                {rowIndex + this.startRowIndex + 1}
                            </span> )
                        }
                    },
                    renderHeaderCell: ({column}, h) => {
                        return (  
                            <div >
                                <div style="margin-top:3px">{column.title}</div>
                                <el-link on-click={()=>{this.rowShow()}} style="font-size:12px;color:#404eff;height:30px"> 
                                    <el-tooltip content={this.$LANG('0852', '清除条件')} effect="light">
                                        <i class="iconfont icon-shanchu1"  ></i>
                                    </el-tooltip>
                                </el-link>
                            </div>
                        )
                    },
                }
                let v_oper ={
                    field: "oper0",
                    key: "oper",
                    title: this.$LANG('0330', '操作'),
                    width: 75,
                    align: "center",
                    fixed:"right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ( 
                            <div>
                                <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link   on-click={()=>{this.editRec(row,'Y' )}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('0139', '查看')}</span></el-link>
                            </div>                                
                        )  
                    },
                }
                this.vueCol.unshift(v_rownum) 
                this.vueCol.push(v_oper)
                this.applyFieldSettingRows()
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','434494','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlArr.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','434494','lstseq','3','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.listArr.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','434494','lstseq','4','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.refArr.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','434494','lstseq','5','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.supCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
 
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 32%;
        color:#409EFF;
    }
    .item-width2  {
        width: 97%;
    }
    .active { 
        color:#D200D2; 
    } 
 
</style>
<style lang="less">
 
    .table-foot-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #b2d3fa !important;
        font-weight:700 !important;
        padding: 2px !important;
        line-height: 25px !important;
        text-align:left !important;
        height: 15px !important;
   
    }
    .table-head-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        padding:0px !important;
        padding-top:4px !important;
        text-align:center !important;
        border-width: 1px !important;
        border-color: #808695 !important;
    }
    .table-head-cell-class2 {
        font-size: 12px !important;
        color: rgb(134, 4, 4) !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        border-width: 1px !important;
        border-color: #808695 !important;
        padding:6px !important;
    }
    .table-body-cell-class1 {
        font-size: 12px !important;
        color: black !important;
        border-width: 1px !important;
        padding:2px !important;
        border-color: #808695 !important;
    }
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table__body {
        width: 100%;
        // 使表格兼容safari，不错位
        table-layout: fixed !important;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 3px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-table__body tr.current-row > td {
        background-color: #F1e1ff !important;
    } 
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
